import { Component, Input, ViewChild } from '@angular/core'
import { AdobePDFViewerComponent } from '../adobe-pdf-viewer/adobe-pdf-viewer'
import { IconNamesEnum, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'

@Component({
    selector: 'pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss'],
    imports: [NgxBootstrapIconsModule, AdobePDFViewerComponent]
})
export class PDFViewerComponent {
  @ViewChild(AdobePDFViewerComponent) adobePDFViewerComponent: AdobePDFViewerComponent | undefined
  @Input() set href(href:string) {
    this.document = {
      id: 'xxx',
      file_extension: 'pdf',
      cdn_path: href
    }
  }
  @Input() document: any = {}

  public iconNames = IconNamesEnum

  openPdfFile() {
    this.adobePDFViewerComponent!.displayPDF(this.document)
  }
}